import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import DateCell from '../../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../../elements/Table/Cells/StatusCell'
import { Link, withRouter } from 'react-router-dom'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import FileCell from '../../../../elements/Table/Cells/FileCell'
import PropTypes from 'prop-types'
import { formatQueryParams } from '../../../../modules/Utils'

const columns = [
  {
    Header: 'Code',
    accessor: 'code',
    width: 300,
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/operations/engineering/qc/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },
  { Header: 'Rev', accessor: 'revision', width: 50 },
  {
    Header: 'Enquiry',
    accessor: 'enquiry.code',
    hideable: true,
    hideDefault: false,
    width: 120,
  },
  {
    Header: 'Sales Order',
    accessor: 'order.code',
    hideable: true,
    hideDefault: false,
    width: 120,
  },
  { Header: 'Title', accessor: 'title', style: { textAlign: 'left' } },
  { Header: 'Type', accessor: 'type.code', width: 200 },
  { Header: 'Status', accessor: 'status', width: 200, Cell: StatusCell },
  {
    Header: 'Accepted Date',
    accessor: 'accepted.date',
    Cell: DateCell,
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Accepted By',
    accessor: 'accepted.fn',
    hideable: true,
    hideDefault: true,
  },
  /*{
    Header: 'Issue Date',
    accessor: 'issue.date',
    Cell: DateCell,
    hideable: true,
    hideDefault: true,
  },*/
  /*{
    Header: 'Issued',
    accessor: 'issuance.issued',
    width:200,
    Cell: ({value}) => value === true && <span>Issued</span>,
    hideable: true,
    hideDefault: false,
  },*/
  {
    Header: 'File',
    accessor: 'file',
    Cell: FileCell,
    width: 100,
    hideable: true,
    hideDefault: false,
  },
]

function QCList (props) {
  const { list, fetch, fetching, company, onChangeCompany, enquiryID, hideCompany } = props
  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      ExtraOptionsButtons={() =>
        hideCompany !== true && (
          <OrganisationsSelect
            value={company}
            onChange={onChangeCompany}
            placeholder={'Filter by a company'}
            size={'small'}
            style={{ width: '450px', paddingRight: 20, float: 'right' }}
          />
        )
      }
      CreateButton={() => (
        <Button
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={() => {
            props.history.push({
              pathname: `/operations/engineering/qc/new/`,
              search: formatQueryParams('enquiryID', enquiryID, true),
            })
          }}>
          New
        </Button>
      )}
      columns={columns}
    />
  )
}

QCList.propTypes = {
  list: PropTypes.any,
  fetch: PropTypes.any,
  fetching: PropTypes.any,
  company: PropTypes.any,
  onChangeCompany: PropTypes.any,
  hideCompany: PropTypes.bool,
}
QCList.defaultProps = {}

export default withRouter(QCList)
